import { Observable, merge, BehaviorSubject } from 'rxjs';
import { withLatestFrom, map, tap } from 'rxjs/operators';

interface FilterControl<T> {
	setValue: (value: T, options?: any) => void;
	valueChanges: Observable<T>;
}

export class FilterCollection<T> implements FilterControl<T> {
	private readonly _filters: FilterControl<Partial<T>>[] = [];
	private _value = new BehaviorSubject<T>({} as T);

	constructor(...filters: FilterControl<Partial<T>>[]) {
		this._filters = filters;
		this.valueChanges = merge(
			...this._filters.map((f) => f.valueChanges)
		).pipe(
			withLatestFrom(this._value),
			map(([newValue, oldValue]) => ({
				...oldValue,
				...newValue,
			})),
			tap((value) => this._value.next(value))
		);
	}

	readonly valueChanges: Observable<T>;

	setValue(value: T): void {
		this._filters.forEach((f) => f.setValue(value, { emitEvent: false }));
		this._value.next(value);
	}
}
